module.exports = "pegasus_template/assets/theme3/medium/3.jpg";